<template>
    <div class="card-component">
        <DxTabPanel>
            <DxItem title="Sucesos" icon="fa fa-bell-exclamation">
                <RejillaSucesos :osciloProp="oscilo"></RejillaSucesos>
            </DxItem>
            <!-- <DxItem title="Medidas" icon="fa fa-chart-bar">
                <RejillaFicherosMedida :osciloProp="oscilo"></RejillaFicherosMedida>
            </DxItem> -->
        </DxTabPanel>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useApi } from '@/.shared/.api/integration';
import type { OsciloDetalleModel } from '@/.shared/.api';
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import RejillaSucesos from '@/components/sucesos/RejillaSucesos.vue';
import RejillaFicherosMedida from '@/components/ficheros-medida/RejillaFicherosMedida.vue';

const props = defineProps<{ osciloProp: OsciloDetalleModel }>();
const oscilo = computed(() => props.osciloProp);

const api = useApi();

</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";
</style>